import { useSelector } from 'react-redux';

import { IOfferChatsState } from '../../reducers/chat';
import { offerChatSelector } from '../../selectors/offerChat';

export function useOfferChatSelector(): IOfferChatsState {
  return useSelector(offerChatSelector);
}
